import Axios from 'axios';
import { tsvParse as d3TsvParse } from 'd3-dsv';


const LOAD_START = 'DevicesVis/VisState/LOAD_START';
const LOAD_SUCCESS = 'DevicesVis/VisState/LOAD_SUCCESS';
const LOAD_ERROR = 'DevicesVis/VisState/LOAD_ERROR';
const CHANGE_DEVICE = 'DevicesVis/VisState/CHANGE_DEVICE';

let cache = {};

const initialState = {
  loading: true,
  data: false,
  geojson: false,
  selectedDevice: "Vollautomat"
}

export function changeDevice(device) {
  return dispatch => dispatch({ type: CHANGE_DEVICE, device });
}

export function loadData() {
  return dispatch => {
    dispatch({ type: LOAD_START });

    if (cache['devices_data'] !== undefined) {
      dispatch({ type: LOAD_SUCCESS, data: cache['devices_data']});
    } else {
      Axios.get(`data/geraete_ids.tsv`)
        .then(res => {
          const data = d3TsvParse(res.data);
          cache['devices_data'] = data;
          Axios.get(`data/germany.topo.json`)
            .then(res => {
              const geo = res.data;
              cache['devices_geo'] = geo;
              dispatch({ type: LOAD_SUCCESS, geo, data });
            })
            .catch(err => dispatch({ type: LOAD_ERROR }));
        })
        .catch(err => dispatch({ type: LOAD_ERROR }));
      }
    }
}



export default function AppReducer(state = initialState, action = {}) {
  switch(action.type) {
    case LOAD_START:
     return Object.assign({}, state, { loading: true });

    case LOAD_SUCCESS:
     return Object.assign({}, state, {
       loading: false,
       data: action.data,
       geojson: action.geo
     });

     case CHANGE_DEVICE:
      return Object.assign({}, state, {
        selectedDevice: action.device
      });


    default:
      return Object.assign({}, state)
  }
};



// WEBPACK FOOTER //
// ./src/modules/DevicesVis/VisState.js